import { useState } from 'react';
import type { OrderFlowRule } from 'domain-model/types/oms';
import {
  Card,
  CardBody,
  CardHeader,
  Collapse,
  Badge,
  Button,
} from 'reactstrap';

interface RuleCardProps {
  rule: OrderFlowRule;
  isSelected: boolean;
  onToggle: (selected: boolean) => void;
}

export function RuleCard({ rule, isSelected, onToggle }: RuleCardProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Card className={`mb-3 ${isSelected ? 'border-primary' : ''}`}>
      <CardHeader>
        <div className="d-flex align-items-start">
          <div className="form-check me-3">
            <input
              className="form-check-input"
              type="checkbox"
              checked={isSelected}
              onChange={e => onToggle(e.target.checked)}
              id={`rule-${rule.id}`}
            />
          </div>
          <div className="flex-grow-1">
            <h6 className="card-title mb-2">{rule.name}</h6>
            <div className="d-flex flex-wrap gap-2">
              <Badge color="secondary">
                {rule.checks.length} kontroll
                {rule.checks.length !== 1 ? 'er' : ''}
              </Badge>
              {rule.onAllChecksPassAction && (
                <Badge color="info">
                  <i className="bi bi-gear me-1"></i>
                  Åtgärd
                </Badge>
              )}
              {rule.dontEvaluateMoreRulesWhenFails && (
                <Badge color="warning">
                  <i className="bi bi-exclamation-triangle me-1"></i>
                  Stoppar vid fel
                </Badge>
              )}
            </div>
          </div>
        </div>
      </CardHeader>

      <CardBody className="pt-0">
        <Button
          color="link"
          size="sm"
          className="p-0 text-decoration-none"
          onClick={() => setIsExpanded(!isExpanded)}
          aria-expanded={isExpanded}
        >
          <i className={`bi bi-chevron-${isExpanded ? 'up' : 'down'} me-1`}></i>
          Visa detaljer
        </Button>

        <Collapse isOpen={isExpanded} className="mt-3">
          <div className="mb-3">
            <h6 className="fw-bold mb-2">Kontroller:</h6>
            <div className="d-flex flex-column gap-2">
              {rule.checks.map((check, index) => (
                <div key={index} className="p-2 bg-light rounded">
                  <div className="mb-1 fw-medium">{check.description}</div>
                </div>
              ))}
            </div>
          </div>

          {rule.onAllChecksPassActionLocalizedName && (
            <div>
              <h6 className="fw-bold mb-2">Åtgärd vid godkänd kontroll:</h6>
              <div className="p-2 bg-primary bg-opacity-10 border border-primary border-opacity-25 rounded">
                <p className="mb-1 fw-medium text-primary">
                  {rule.onAllChecksPassActionLocalizedName}
                </p>
              </div>
            </div>
          )}
        </Collapse>
      </CardBody>
    </Card>
  );
}
